import { Progress } from "@chakra-ui/react"
import { FC, useContext, useEffect, useState } from "react"
import { RenderContext } from "../../CreateContext";

type Props ={
    Media:{
        COMMENT: string;
        DISPLAY_SIZE: string;
        ID: number;
        OWNER_TOPIC_ID: number;
        TITLE: string;
        TYPE: string;
        URL: string;
    } | undefined
    onClose:() => void
    paginate:(newDirection: number) => void
    index :number
    MoveEndFlag: boolean
    modalCanCloseFlag:boolean
}

export const ModalProgress:FC<Props> =(props)=>{
    const { paginate, index, Media, onClose, MoveEndFlag, modalCanCloseFlag } =props
    const {settings} = useContext(RenderContext);

    const modalContentLifeTime = settings.find(setting => setting.KEY_NAME === "modal_content_life_time");
    const lifeTime = typeof modalContentLifeTime?.VALUE === "number" ? modalContentLifeTime.VALUE : 30

    const addProgress = 5 / lifeTime
    
    // 自動で詳細画面の切り替え
    let IntervalId: NodeJS.Timeout | null = null;
    const [progress, setProgress] = useState(0)
    const [isPaused, setIsPaused] = useState(false);
    useEffect(() => {
        if (!isPaused) {
            if(!Media || MoveEndFlag ){
                IntervalId = setInterval(() => {
                        
                    setProgress((prevProgress) => {
                        let newProgress = prevProgress + addProgress;
                        if (newProgress >= 100) {
                            if(modalCanCloseFlag ===true){
                                onClose();
                            }
                            if(!modalCanCloseFlag){
                                paginate(1);
                            }
                        newProgress = 0
                        }
                        return newProgress;
                    });
                }, 50);
            }
        } else {
        clearInterval(IntervalId as NodeJS.Timeout);
        setProgress(0);
        setTimeout(() => {
            setIsPaused(false);
        }, 3000);
        }
    
        const handleTouchStart = () => {
        setIsPaused(true);
        };
    
        document.addEventListener('touchstart', handleTouchStart);
    
        return () => {
        document.removeEventListener('touchstart', handleTouchStart);
        clearInterval(IntervalId as NodeJS.Timeout);
        };
        }, [isPaused, index, MoveEndFlag,modalCanCloseFlag]);
    return(
        <Progress value={progress} colorScheme="yellow"  />
    )
}